import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import SiteCopyForm from './SiteCopyForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewSiteCopyModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.createSiteCopy( { ...values } )
        .then( ( newSiteCopy ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newSiteCopy );
        } );
    }



    render() {
        const { tag } = this.props;
        return (
            <DLModal title='New Site Copy'
            closeHandler={ this.props.closeModal }>
                <div>
                    <SiteCopyForm onSubmit={ this.submitHandler } initialValues={ tag } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createSiteCopy: ( data ) => {
            return dAPI.post( '/admin/dynamicCopy', data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewSiteCopyModal );
